export const NO_SHOPIFY_PRODUCT_ID = 'NO_PRODUCT_ID';
//# sourceMappingURL=productId.js.map